import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";
import { useApiKeys, useApiKeyMutations } from "#app/hooks/settings/use-api-key-mutations";
import { ApiKeyDetailView } from "#app/components/settings/api-key-detail-view";
import { TrashConfirmDialog } from "#app/components/settings/trash-confirm-dialog";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function ApiKeyDetailPage() {
  const { apiKeyId } = Route.useParams();
  const { push, replace } = useAppNavigate();
  const { apiKeys, isLoading } = useApiKeys();
  const { revokeApiKey } = useApiKeyMutations();

  const [showRevoke, setShowRevoke] = useState(false);

  const apiKey = apiKeys.find((k: any) => k.apiKeyId === apiKeyId);

  if (isLoading && !apiKey) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (!apiKey) {
    replace("/settings/api");
    return null;
  }

  async function handleRevoke() {
    await revokeApiKey(apiKeyId);
    replace("/settings/api");
  }

  return (
    <>
      <ApiKeyDetailView
        apiKey={apiKey}
        onBack={() => replace("/settings/api")}
        onEdit={() =>
          push(`/settings/api/keys/${apiKeyId}/edit`)
        }
        onRevoke={() => setShowRevoke(true)}
      />

      <TrashConfirmDialog
        open={showRevoke}
        onOpenChange={(open) => { if (!open) setShowRevoke(false); }}
        title="Revoke API key?"
        description={`This will permanently revoke "${apiKey.name}". Any applications using this key will lose access immediately.`}
        confirmLabel="Revoke"
        onConfirm={handleRevoke}
      />
    </>
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/api/keys/$apiKeyId/",
)({ component: withPermission("workspace.integrations", ApiKeyDetailPage) });
